import { LoadingOverlay } from '@mantine/core'
import { useParams } from 'next/navigation'
import { createContext, FC, ReactNode, useContext } from 'react'

import { useInstituteCurriculumItemQuery } from '@/features/institute/queries/useInstituteCurriculumItemQuery'
import { IInstituteCurriculumItem } from '@/features/institute/types'
import { useAuth } from './Auth'

export interface ICurriculumContextState {
  curriculum: IInstituteCurriculumItem | null
  refetch: () => void
}

const CurriculumContext = createContext<ICurriculumContextState>({
  curriculum: null,
  refetch: () => {},
})

export interface ICurriculumProviderProps {
  children: ReactNode
}

const CurriculumProvider: FC<ICurriculumProviderProps> = ({ children }) => {
  const { curriculumId } = useParams() as { curriculumId: string }
  const { profile } = useAuth()
  const { data, isLoading, refetch } = useInstituteCurriculumItemQuery(
    profile?.instituteCode as string,
    curriculumId,
    profile?.id as number,
  )

  if (isLoading)
    return (
      <LoadingOverlay
        visible={true}
        overlayProps={{ radius: 'sm', blur: 2, backgroundOpacity: 0 }}
        loaderProps={{ color: 'gray', size: 'xl' }}
      />
    )

  return (
    <CurriculumContext.Provider value={{ curriculum: data ?? null, refetch }}>
      {children}
    </CurriculumContext.Provider>
  )
}

export default CurriculumProvider
export const useCurriculum = () => useContext(CurriculumContext)
